import React from 'react';
import { Grid, FormControl, RadioGroup, FormControlLabel, Radio } from '@mui/material';
import { languageOptions } from './constant';

export const LanguagePicker = ({
  intl, options, onValueChange,
  field = 'language',
  classes = {}, required = false,
  name = 'language',
  label = 'language',
  radioGroupProps = {
    style: { display: 'flex', justifyContent: 'center' }
  },
  formControlProps = {},
}) => {
  return (
    <FormControl {...formControlProps}>
      <RadioGroup
        {...radioGroupProps}
        row
        aria-label={label}
        name={name}
        value={options[field] || ''}
        onChange={event => onValueChange(field, event.target.value, options[field])}
      >
        {languageOptions.map(({ value, labelId }) => (
          <FormControlLabel
            key={value}
            value={value}
            control={<Radio color="primary" className={classes.radioOption} style={{ paddingTop: '2px', paddingBottom: '2px' }} />}
            label={intl.formatMessage({ id: labelId })}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
};
